const TRANSLATIONS = {
    en: {
        body: "I'm not sure what you're looking for, but its not here.",
        title: '404 Not Found'
    }
}

export default TRANSLATIONS